'use client'
import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'
import { FormInput } from './FormInput'

type PasswordInputProps = {
  error?: string
  apiError?: string
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

export function PasswordInput({ ...props }: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="group relative">
      <FormInput type={showPassword ? 'text' : 'password'} {...props} />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className={`absolute right-4 top-[18px] text-white/70 transition-colors hover:text-white ${
          showPassword ? 'visible' : 'invisible group-hover:visible'
        }`}
      >
        {showPassword ? (
          <EyeOff size={20} aria-label="Hide password" />
        ) : (
          <Eye size={20} aria-label="Show password" />
        )}
      </button>
    </div>
  )
}
